import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import { store } from '../index';
import { USER_LOGOUT } from "store/app/authentication/login/constants";
import moment from "moment";

const superagent = superagentPromise(_superagent, Promise);
const { apiUrl } = window.__ENV || {};

const responseBody = (res) => {
    if (res.body) {
        return res.body
    }
    else if (res.text) {
        return res.text
    }
    else {
        return null
    }
}

const handleErrors = async (err) => {
    if (err && err.status === 401) {
        store.dispatch({ type: USER_LOGOUT });
    }
};

const requests = {
    post: (url, body) =>
        superagent
            .post(url, body)
            .set("Content-Type", "application/json")
            .on("error", handleErrors)
            .then(responseBody),
    postEncoded: (url, body) =>
        superagent
            .post(url, body)
            .set("Content-Type", "application/x-www-form-urlencoded")
            .on("error", handleErrors)
            .then(responseBody),
    postWithToken: (url, token, body) =>
        superagent
            .post(url, body)
            .set("Content-Type", "application/json")
            .on("error", handleErrors)
            .set("Authorization", `Bearer ${token}`)
            .then(responseBody),
    postMultiPartWithToken: (url, token, body) =>
        superagent
            .post(url, body)
            // .set("Content-Type", "multipart/form-data")
            .on("error", handleErrors)
            .set("Authorization", `Bearer ${token}`)
            .then(responseBody),
    getWithToken: (url, token) =>
        superagent
            .get(url)
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${token}`)
            .on("error", handleErrors)
            .then(responseBody),
    getWithoutToken: (url) =>
        superagent
            .get(url)
            .responseType('blob')
            .set("Content-Type", "application/json")
            // .set("Authorization", `Bearer ${token}`)
            .on("error", handleErrors)
            .then(responseBody),
    deleteWithToken: (url, token) =>
        superagent
            .del(url, token)
            .set("Content-Type", "application/json")
            .on("error", handleErrors)
            .set("Authorization", `Bearer ${token}`)
            .then(responseBody),
    deletebodyWithToken: (url, body, token) =>
        superagent
            .del(url)
            .send(body)
            .set("Content-Type", "application/json")
            .on("error", handleErrors)
            .set("Authorization", `Bearer ${token}`)
            .then(responseBody),
    putWithToken: (url, body, token) =>
        superagent
            .put(url, body, token)
            .set("Content-Type", "application/json")
            .on("error", handleErrors)
            .set("Authorization", `Bearer ${token}`)
            .then(responseBody),
}

const authentication = {
    login: (formData) => {
        return requests.post(`${apiUrl}/api/Auth/Login`, formData)
    },
    forgotPassword: (email) => {
        return requests.post(`${apiUrl}/api/Auth/ForgotPassword?Email=${encodeURIComponent(email)}`);
    },
    resetPassword: (formData) => {
        return requests.post(`${apiUrl}/api/Auth/ResetPassword`, formData);
    },
    enableAccount: (formData) => {
        return requests.post(`${apiUrl}/api/Auth/EnableUser`, formData);
    },
    profile: (accessToken) => {
        return requests.getWithToken(`${apiUrl}/api/User/Profile`, accessToken);
    },
    changePassword: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Auth/ChangePassword`, accessToken, formData);
    },
}

const dashboards = {
    getDashboardDetails: (accessToken, startDate, endDate) => {
        let url = `${apiUrl}/api/Dashboard/Details`;
        if (startDate && endDate) {
            url += `?StartDate=${moment(startDate, "DD-MM-YYYY").format("MM-DD-YYYY")}&EndDate=${moment(endDate, "DD-MM-YYYY").format("MM-DD-YYYY")}`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getFormFieldOption: (accessToken, search, page, pageSize, field) => {
        let url = `${apiUrl}/odata/FormFieldList?count=true`;
        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (search || field) {
            url += "&filter=";
            const filterArray = [];

            if (search) {
                filterArray.push(`contains(tolower(FieldName),tolower('${encodeURIComponent(search)}'))`);
            }
            if (field) {
                const StringfyMailList = field?.map((item) => `'${item}'`).join(', ');
                filterArray.push(`Id in (${encodeURIComponent(StringfyMailList)})`);
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    getUserDashboardDetails: (accessToken, dashboardFilter) => {
        const { period, periodfrom, periodto, periodtype, technicalmanager, customer, location, region, state, district, anticoccidial, agp, probiotic } = dashboardFilter || {};

        let url = `${apiUrl}/api/Dashboard/UserDashoardInfo`;

        const filterBody = {
            period: period,
            startDate: periodfrom ? moment(periodfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            endDate: periodto ? moment(periodto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            periodtype: periodtype,
            customerEmail: customer,
            location: location,
            region: region,
            state: state,
            district: district,
            anticoccidial: anticoccidial,
            agp: agp,
            probiotic: probiotic,
            technicalManagerEmail: technicalmanager
        }

        return requests.postWithToken(url, accessToken, filterBody);
    },

    getPrimaryEntityGraphDetails: (accessToken, dashboardFilter) => {
        const { graphname, primarygraphyaxis, period, periodfrom, periodto, periodtype, technicalmanager, customer, location, region, state, district, anticoccidial, agp, probiotic, field } = dashboardFilter || {};

        let url = `${apiUrl}/api/Dashboard/PrimaryEntityGraph`;

        const filterBody = {
            graphName: graphname ? graphname?.trim() : null,
            yaxis: primarygraphyaxis || null,
            period: period,
            startDate: periodfrom ? moment(periodfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            endDate: periodto ? moment(periodto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            periodtype: periodtype,
            customerEmail: customer,
            location: location,
            region: region,
            state: state,
            district: district,
            anticoccidial: anticoccidial,
            agp: agp,
            probiotic: probiotic,
            formFieldIds: field,
            technicalManagerEmail: technicalmanager
        }

        return requests.postWithToken(url, accessToken, filterBody);
    },
    getTMLSGraphDetails: (accessToken, dashboardFilter) => {
        const { tmlsgraphyaxis, period, periodfrom, periodto, periodtype, technicalmanager, customer, location, region, state, district, anticoccidial, agp, probiotic } = dashboardFilter || {};
        let url = `${apiUrl}/api/Dashboard/TMLSGraph`;

        const filterBody = {
            yaxis: tmlsgraphyaxis || null,
            period: period,
            startDate: periodfrom ? moment(periodfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            endDate: periodto ? moment(periodto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            periodtype: periodtype,
            customerEmail: customer,
            location: location,
            region: region,
            state: state,
            district: district,
            anticoccidial: anticoccidial,
            agp: agp,
            probiotic: probiotic,
            technicalManagerEmail: technicalmanager
        }

        return requests.postWithToken(url, accessToken, filterBody);
    },
    getDysbacteriosisGraphDetails: (accessToken, dashboardFilter) => {
        const { dysbacteriosisgraphyaxis, period, periodfrom, periodto, periodtype, technicalmanager, customer, location, region, state, district, anticoccidial, agp, probiotic } = dashboardFilter || {};

        let url = `${apiUrl}/api/Dashboard/DysbacteriosisGraph`;

        const filterBody = {
            yaxis: dysbacteriosisgraphyaxis || null,
            period: period,
            startDate: periodfrom ? moment(periodfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            endDate: periodto ? moment(periodto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            periodtype: periodtype,
            customerEmail: customer,
            location: location,
            region: region,
            state: state,
            district: district,
            anticoccidial: anticoccidial,
            agp: agp,
            probiotic: probiotic,
            technicalManagerEmail: technicalmanager
        }

        return requests.postWithToken(url, accessToken, filterBody);
    },
}

const users = {
    getUserList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {

        const { firstname, lastname, displayname, emailaddress, mobilenumber, role, asignedstatecount, userstatus, accountstatus } = filters || {};
        page = parseInt(page, 10);

        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/UserList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=DisplayName asc`
        }
        if (firstname || lastname || displayname || emailaddress || mobilenumber || role || asignedstatecount || userstatus || accountstatus) {
            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];
            if (firstname) {
                if (firstname.toLowerCase() === nullFilter) {
                    filterArray.push('firstName eq null');
                } else {
                    filterArray.push(`contains(tolower(firstName),tolower('${firstname}'))`);
                }
            }
            if (lastname) {
                if (lastname.toLowerCase() === nullFilter) {
                    filterArray.push('lastName eq null');
                } else {
                    filterArray.push(`contains(tolower(lastName),tolower('${lastname}'))`);
                }
            }
            if (displayname) {
                if (displayname.toLowerCase() === nullFilter) {
                    filterArray.push('displayName eq null');
                } else {
                    filterArray.push(`contains(tolower(displayName),tolower('${displayname}'))`);
                }
            }
            if (emailaddress) {
                if (emailaddress.toLowerCase() === nullFilter) {
                    filterArray.push('email eq null');
                } else {
                    filterArray.push(`contains(tolower(email),tolower('${emailaddress}'))`);
                }
            }
            if (mobilenumber) {
                if (mobilenumber.toLowerCase() === nullFilter) {
                    filterArray.push('mobileNumber eq null');
                } else {
                    filterArray.push(`contains(tolower(mobileNumber),tolower('${mobilenumber}'))`);
                }
            }
            if (asignedstatecount) {
                if (asignedstatecount.toLowerCase() === nullFilter) {
                    filterArray.push('AssignedStatesCount eq null');
                } else {
                    filterArray.push(`AssignedStatesCount eq ${asignedstatecount}`);
                }
            }
            if (role) {
                if (role.toLowerCase() === nullFilter) {
                    filterArray.push('userRoleName eq null');
                } else {
                    if (role.includes("%2C") || role.includes(",")) {
                        const splitRole = role.split("%2C");
                        const multiSelectRole = splitRole?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`userRoleName in (${multiSelectRole})`);
                    }
                    else {
                        filterArray.push(`tolower(userRoleName) eq tolower('${role}')`);
                    }

                }
            }
            if (userstatus) {
                if (userstatus.toLowerCase() === 'active') {
                    filterArray.push('isActive eq true');
                } else {
                    filterArray.push(`isActive eq false`);
                }
            }
            if (accountstatus) {
                if (accountstatus.toLowerCase() === 'enabled') {
                    filterArray.push('isEnabled eq true');
                } else {
                    filterArray.push(`isEnabled eq false`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken)
    },
    getUserDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/User/Details?UserId=${id}`, accessToken);
    },
    userCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/User/Create`, accessToken, formData);
    },
    userEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/User/Update`, accessToken, formData);
    },
    getRoles: (accessToken, filter) => {
        let url = `${apiUrl}/odata/RolesList?$orderby=Rank asc`;
        if (filter) {
            url += `&$filter=contains(tolower(RoleName), tolower('${encodeURIComponent(filter)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getSelectedStates: (accessToken, selectedRegion) => {
        let url = `${apiUrl}/odata/StatesList?$orderby=StateName asc&$select=StateName,Id,RegionId&$filter=IsActive eq true`;

        if (selectedRegion && selectedRegion?.length > 0) {
            const multiSelectRegion = selectedRegion?.map((item) => `'${item}'`).join(', ');

            url += ` and (RegionId in (${multiSelectRegion}))`;
        }

        return requests.getWithToken(url, accessToken);
    }
}
const farmRecords = {
    getCustomerOption: (accessToken, search, page, pageSize) => {
        let url = `${apiUrl}/odata/CustomerMasterList?orderby=CustomerName asc`;
        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (search) {
            if (search.includes(",")) {
                const emailList = search?.split(",");
                const StringfyMailList = emailList?.map((item) => `'${item}'`).join(', ');
                url += `&filter=Email in (${encodeURIComponent(StringfyMailList)})`;
            }
            else {
                url += `&filter=contains(tolower(CustomerName),tolower('${encodeURIComponent(search)}')) or contains(tolower(email),tolower('${encodeURIComponent(search)}'))`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    getTechnicalManagerOption: (accessToken, search, page, pageSize) => {
        let url = `${apiUrl}/odata/UserList?count=true&orderby=DisplayName asc`;
        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}&filter=(UserRoleName in ('User','Administrator','Master User'))`;
        }
        else {
            url += `&filter=(UserRoleName in ('User','Administrator','Master User'))`;
        }
        if (search) {
            if (search.includes(",")) {
                const emailList = search?.split(",");
                const StringfyMailList = emailList?.map((item) => `'${item}'`).join(', ');
                url += ` and Email in (${encodeURIComponent(StringfyMailList)})`;
            }
            else {
                url += ` and (contains(tolower(DisplayName),tolower('${encodeURIComponent(search)}')) or contains(tolower(Email),tolower('${encodeURIComponent(search)}')))`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    getLocationOption: (accessToken, search) => {
        let url = `${apiUrl}/api/FarmRecords/Location/List`;
        if (search) {
            url += `?filter=contains(tolower(locationName),tolower('${encodeURIComponent(search)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getRegionOption: (accessToken, search, type, page, pageSize) => {
        let url = `${apiUrl}/odata/RegionList?orderby=RegionName asc`;

        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (type === "filter") {
            url += `&filter=IsActive eq true or IsActive eq false`;
        }
        else {
            url += `&filter=IsActive eq true`;
        }

        if (search) {
            url += ` and contains(tolower(RegionName),tolower('${encodeURIComponent(search)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getStateOptionCreate: (accessToken, search, selectedRegion, page, pageSize) => {
        let url = `${apiUrl}/odata/StatesList?orderby=StateName asc`;

        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}&filter=IsActive eq true`;
        }
        else {
            url += `&filter=IsActive eq true`;
        }
        if (selectedRegion && selectedRegion?.length > 0) {
            const regionIds = selectedRegion?.map((data) => data.value)
            const multiSelectRegion = regionIds?.map((item) => `'${item}'`).join(', ');

            url += ` and (RegionId in (${multiSelectRegion}))`;
        }
        if (search) {
            url += ` and contains(tolower(StateName),tolower('${encodeURIComponent(search)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getStateOption: (accessToken, search, region, page, pageSize) => {
        let url = `${apiUrl}/odata/StatesList?orderby=StateName asc`;

        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (search || region) {
            url += "&filter=";
            const filterArray = [];
            if (search) {
                filterArray.push(`contains(tolower(StateName),tolower('${encodeURIComponent(search)}'))`);
            }
            if (region) {
                const splitRegion = region?.split(",");
                const appendQuot = splitRegion?.map((reg) => `'${reg}'`);
                const combineRegion = appendQuot?.join();
                filterArray.push(`RegionName in (${combineRegion})`);
            }
            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    getDistrictOption: (accessToken, search, state, region, page, pageSize) => {
        let url = `${apiUrl}/odata/DistrictList?orderby=District asc`;

        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (search || state || region) {
            url += "&filter=";
            const filterArray = [];
            if (search) {
                filterArray.push(`contains(tolower(District),tolower('${encodeURIComponent(search)}'))`);
            }
            if (state) {
                const splitState = state?.split(",");
                const appendQuot = splitState?.map((reg) => `'${reg}'`);
                const combineState = appendQuot?.join();
                filterArray.push(`StateName in (${combineState})`);
            }
            if (region) {
                const splitRegion = region?.split(",");
                const appendQuot = splitRegion?.map((reg) => `'${reg}'`);
                const combineRegion = appendQuot?.join();
                filterArray.push(`RegionName in (${combineRegion})`);
            }
            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    getAnticocidalOption: (accessToken, search, page, pageSize) => {
        let url = `${apiUrl}/odata/GetAnticoccidialList?orderby=Anticoccidial asc`;

        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (search) {
            url += `&filter=contains(tolower(Anticoccidial),tolower('${encodeURIComponent(search)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getAGPOption: (accessToken, search, page, pageSize) => {
        let url = `${apiUrl}/odata/GetAGPList?orderby=Agp asc`;

        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (search) {
            url += `&filter=contains(tolower(Agp),tolower('${encodeURIComponent(search)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getProbioticOption: (accessToken, search, page, pageSize) => {
        let url = `${apiUrl}/odata/GetProbioticList?orderby=Probiotic asc`;
        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }

        if (search) {
            url += `&filter=contains(tolower(Probiotic),tolower('${encodeURIComponent(search)}'))`;
        }
        return requests.getWithToken(url, accessToken);
    },
    getFarmRecordList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {
        page = parseInt(page, 10);
        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let sortData = {};
        if (sortOrder && sortDirection) {
            sortData = {
                column: sortOrder,
                order: sortDirection
            }
        }
        else {
            sortData = {
                column: "recordsIndex",
                order: "desc"
            }
        }

        const { recordstatus, recordno, farmname, technicalmanageremail, inspectedfrom, inspectedto, submittedfrom, submittedto, customer, location, region, state,
            district, age, examinedbirdscount, totalnoofbirdsplaced, anticoccidial, agp, probiotic, remark, totalBirdImageCount, } = filters || {};
        const postData = {
            pageIdx: page - 1,
            pageSize: pageSize,
            recordStatus: recordstatus,
            recordIdx: recordno,
            farmName: farmname,
            technicalManagerEmail: technicalmanageremail ? technicalmanageremail.split(",") : null,
            inspectionStartDate: inspectedfrom ? moment(inspectedfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            inspectionEndDate: inspectedto ? moment(inspectedto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            submissionStartDate: submittedfrom ? moment(submittedfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            submissionEnddate: submittedto ? moment(submittedto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            locations: location ? location.split(",") : null,
            customerEmail: customer ? customer.split(",") : null,
            regions: region ? region.split(",") : null,
            states: state ? state.split(",") : null,
            district: district ? district.split(",") : null,
            age: age,
            totalBirdImageCount: totalBirdImageCount,
            examinedBirdsCount: examinedbirdscount,
            totalNoOfBirdsPlaced: totalnoofbirdsplaced,
            anticocidial: anticoccidial ? anticoccidial.split(",") : null,
            agp: agp ? agp.split(",") : null,
            probiotic: probiotic ? probiotic.split(",") : null,
            remark: remark,
            sorting: sortData
        }

        return requests.postWithToken(`${apiUrl}/api/FarmRecords/FarmRecordList`, accessToken, postData)
    },
    getOverallSummaryDetails: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {
        page = parseInt(page, 10);
        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let sortData = {};
        if (sortOrder && sortDirection) {
            sortData = {
                column: sortOrder,
                order: sortDirection
            }
        }
        else {
            sortData = {
                column: "recordsIndex",
                order: "desc"
            }
        }

        const { recordstatus, recordno, farmname, technicalmanageremail, inspectedfrom, inspectedto, submittedfrom, submittedto, customer, location, region, state,
            district, age, examinedbirdscount, totalnoofbirdsplaced, anticoccidial, agp, probiotic, remark, totalBirdImageCount } = filters || {};

        const postData = {
            pageIdx: page - 1,
            pageSize: pageSize,
            recordStatus: recordstatus,
            recordIdx: recordno,
            farmName: farmname,
            technicalManagerEmail: technicalmanageremail ? technicalmanageremail.split(",") : null,
            inspectionStartDate: inspectedfrom ? moment(inspectedfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            inspectionEndDate: inspectedto ? moment(inspectedto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            submissionStartDate: submittedfrom ? moment(submittedfrom, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            submissionEnddate: submittedto ? moment(submittedto, "DD-MM-YYYY").format("YYYY-MM-DD") : null,
            locations: location ? location.split(",") : null,
            customerEmail: customer ? customer.split(",") : null,
            regions: region ? region.split(",") : null,
            states: state ? state.split(",") : null,
            district: district ? district.split(",") : null,
            age: age,
            totalBirdImageCount: totalBirdImageCount,
            examinedBirdsCount: examinedbirdscount,
            totalNoOfBirdsPlaced: totalnoofbirdsplaced,
            anticocidial: anticoccidial ? anticoccidial.split(",") : null,
            agp: agp ? agp.split(",") : null,
            probiotic: probiotic ? probiotic.split(",") : null,
            remark: remark,
            sorting: sortData
        }

        return requests.postWithToken(`${apiUrl}/api/CustomReport/OverAllFarmRecordSummaryReport`, accessToken, postData)
    },
    getFarmRecordDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/FarmRecords/Details?RecordId=${id}`, accessToken);
    },

    getLabRecords: (accessToken, filter) => {
        let url = `${apiUrl}/odata/LabReportList?$count=true`;
        if (filter) {
            url += `&$filter=FarmRecordIndex eq ${encodeURIComponent(filter)}`
        }
        return requests.getWithToken(url, accessToken);
    },
}
const labRecords = {
    getLabRecordList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {
        const { labrecordsno, reportname, farmrecordsno, farmname, technicalmanagerusername, technicalmanageruseremail, customername, customeremail,
            submittedusername, submitteduseremail, inspectedfrom, inspectedto, submittedfrom, submittedto, location, regionname, state, district, anticoccidial, agp, probiotic, observation } = filters || {};

        page = parseInt(page, 10);

        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/LabReportList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=LabRecordsIndex desc`
        }
        if (labrecordsno || reportname || farmrecordsno || farmname || technicalmanagerusername || technicalmanageruseremail || customername || customeremail || submittedusername || submitteduseremail || inspectedfrom || inspectedto || submittedfrom || submittedto || location || regionname || state || district || anticoccidial || agp || probiotic || observation || observation) {

            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];

            if (labrecordsno) {
                if (labrecordsno?.toLowerCase() === nullFilter) {
                    filterArray.push('LabRecordsIndex eq null');
                } else {
                    filterArray.push(`LabRecordsIndex eq ${labrecordsno}`);
                }
            }
            if (reportname) {
                if (reportname?.toLowerCase() === nullFilter) {
                    filterArray.push('ReportName eq null');
                } else {
                    filterArray.push(`contains(tolower(ReportName),tolower('${reportname}'))`);
                }
            }
            if (farmrecordsno) {
                if (farmrecordsno?.toLowerCase() === nullFilter) {
                    filterArray.push('FarmRecordIndex eq null');
                } else {
                    filterArray.push(`FarmRecordIndex eq ${farmrecordsno}`);
                }
            }
            if (farmname) {
                if (farmname?.toLowerCase() === nullFilter) {
                    filterArray.push('farmname eq null');
                } else {
                    filterArray.push(`contains(tolower(farmname),tolower('${farmname}'))`);
                }
            }
            if (technicalmanagerusername) {
                if (technicalmanagerusername?.toLowerCase() === nullFilter) {
                    filterArray.push('technicalmanagerusername eq null');
                } else {
                    filterArray.push(`contains(tolower(technicalmanagerusername),tolower('${technicalmanagerusername}'))`);
                }
            }
            if (technicalmanageruseremail) {
                if (technicalmanageruseremail?.toLowerCase() === nullFilter) {
                    filterArray.push('technicalmanageruseremail eq null');
                } else {
                    filterArray.push(`contains(tolower(technicalmanageruseremail),tolower('${technicalmanageruseremail}'))`);
                }
            }
            if (customername) {
                if (customername?.toLowerCase() === nullFilter) {
                    filterArray.push('customername eq null');
                } else {
                    filterArray.push(`contains(tolower(customername),tolower('${customername}'))`);
                }
            }
            if (customeremail) {
                if (customeremail?.toLowerCase() === nullFilter) {
                    filterArray.push('customeremail eq null');
                } else {
                    filterArray.push(`contains(tolower(customeremail),tolower('${customeremail}'))`);
                }
            }
            if (submittedusername) {
                if (submittedusername?.toLowerCase() === nullFilter) {
                    filterArray.push('SubmittedUserName eq null');
                } else {
                    filterArray.push(`contains(tolower(SubmittedUserName),tolower('${submittedusername}'))`);
                }
            }
            if (submitteduseremail) {
                if (submitteduseremail?.toLowerCase() === nullFilter) {
                    filterArray.push('SubmittedUserEmail eq null');
                } else {
                    filterArray.push(`contains(tolower(SubmittedUserEmail),tolower('${submitteduseremail}'))`);
                }
            }
            if (inspectedfrom && inspectedto) {
                filterArray.push(`inspectiondate ge ${moment(inspectedfrom, "DD-MM-YYYY").format("YYYY-MM-DD")} and inspectiondate le ${moment(inspectedto, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
            }
            if (submittedfrom && submittedto) {
                filterArray.push(`SubmittedTimeStamp ge ${moment(submittedfrom, "DD-MM-YYYY").format("YYYY-MM-DD")} and SubmittedTimeStamp le ${moment(submittedto, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
            }
            if (location) {
                if (location?.toLowerCase() === nullFilter) {
                    filterArray.push('location eq null');
                } else {
                    filterArray.push(`contains(tolower(location),tolower('${location}'))`);
                }
            }
            if (regionname) {
                if (regionname?.toLowerCase() === nullFilter) {
                    filterArray.push('RegionName eq null');
                } else {
                    filterArray.push(`contains(tolower(RegionName),tolower('${regionname}'))`);
                }
            }
            if (state) {
                if (state?.toLowerCase() === nullFilter) {
                    filterArray.push('StateName eq null');
                } else {
                    filterArray.push(`contains(tolower(StateName),tolower('${state}'))`);
                }
            }
            if (district) {
                if (district?.toLowerCase() === nullFilter) {
                    filterArray.push('DistrictName eq null');
                } else {
                    filterArray.push(`contains(tolower(DistrictName),tolower('${district}'))`);
                }
            }
            if (anticoccidial) {
                if (anticoccidial?.toLowerCase() === nullFilter) {
                    filterArray.push('Anticoccidial eq null');
                } else {
                    filterArray.push(`contains(tolower(Anticoccidial),tolower('${anticoccidial}'))`);
                }
            }
            if (agp) {
                if (agp?.toLowerCase() === nullFilter) {
                    filterArray.push('Agp eq null');
                } else {
                    filterArray.push(`contains(tolower(Agp),tolower('${agp}'))`);
                }
            }
            if (probiotic) {
                if (probiotic?.toLowerCase() === nullFilter) {
                    filterArray.push('Probiotic eq null');
                } else {
                    filterArray.push(`contains(tolower(Probiotic),tolower('${probiotic}'))`);
                }
            }
            if (observation) {
                if (location?.toLowerCase() === nullFilter) {
                    filterArray.push('Observation eq null');
                } else {
                    filterArray.push(`contains(tolower(Observation),tolower('${observation}'))`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken)
    },
    getLabRecordDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/LabReport/Details?LabReportId=${id}`, accessToken);
    },
    getFormRecordsOption: (accessToken, filter) => {
        const postData = {
            // pageIdx: 0,
            // pageSize: pageSize,
            recordIdx: filter,
            farmName: filter,
            sorting: {
                column: "recordsIndex",
                order: "desc"
            }
        }
        return requests.postWithToken(`${apiUrl}/api/FarmRecords/FarmRecordList`, accessToken, postData);
    },
    labRecordCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/LabReport/Create`, accessToken, formData);
    },
    labRecordEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/LabReport/Update`, accessToken, formData);
    }
}

const formConfiguration = {
    getFormFieldsList: (accessToken) => {
        return requests.getWithToken(`${apiUrl}/odata/FormFieldList?$orderby=OrderIdx asc`, accessToken);
    },
    updateFormFields: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/FormField/Save`, accessToken, formData);
    },
    deleteFormField: (accessToken, Id) => {
        return requests.deleteWithToken(`${apiUrl}/api/FormField/Delete?FieldId=${Id}`, accessToken);
    },
}

const regionConfiguration = {
    getRegionList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filter) => {
        page = parseInt(page, 10);
        const { regionname, regionstatus } = filter || {};
        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/RegionList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=regionname asc`
        }
        if (regionname || regionstatus) {
            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];
            if (regionname) {
                if (regionname.toLowerCase() === nullFilter) {
                    filterArray.push('regionname eq null');
                } else {
                    filterArray.push(`contains(tolower(regionname),tolower('${regionname}'))`);
                }
            }
            if (regionstatus) {
                if (regionstatus.toLowerCase() === 'active') {
                    filterArray.push('IsActive eq true');
                } else {
                    filterArray.push(`IsActive eq false`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    regionCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/Region/Update`, accessToken, formData);
    },
    regionEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/Region/Update`, accessToken, formData);
    },
}
const stateConfiguration = {
    getStateList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filter) => {
        page = parseInt(page, 10);
        const { statename, regionname, regionstatus, asignedsusercount } = filter || {};
        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/StatesList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=statename asc`
        }
        if (statename || regionname || regionstatus || asignedsusercount) {
            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];
            if (statename) {
                if (statename.toLowerCase() === nullFilter) {
                    filterArray.push('statename eq null');
                } else {
                    filterArray.push(`contains(tolower(statename),tolower('${statename}'))`);
                }
            }
            // if (regionname) {
            //     if (regionname.toLowerCase() === nullFilter) {
            //         filterArray.push('regionname eq null');
            //     } else {
            //         filterArray.push(`contains(tolower(regionname),tolower('${regionname}'))`);
            //     }
            // }
            if (regionname) {
                if (regionname?.toLowerCase() === nullFilter) {
                    filterArray.push('RegionName eq null');
                } else {
                    if (regionname.includes("%2C") || regionname.includes(",")) {
                        const splitRegion = regionname.split(`${regionname.includes("%2C") ? "%2C" : ","}`);
                        const multiSelectRegion = splitRegion?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`(RegionName in (${multiSelectRegion}))`);
                    }
                    else {
                        filterArray.push(`tolower(RegionName) eq tolower('${regionname}')`);
                    }
                }
            }
            if (asignedsusercount) {
                if (asignedsusercount.toLowerCase() === nullFilter) {
                    filterArray.push('AssignedUserCount eq null');
                } else {
                    filterArray.push(`AssignedUserCount eq ${asignedsusercount}`);
                }
            }
            if (regionstatus) {
                if (regionstatus.toLowerCase() === 'active') {
                    filterArray.push('IsActive eq true');
                } else {
                    filterArray.push(`IsActive eq false`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    stateCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/State/Update`, accessToken, formData);
    },
    getStateDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/Setting/State/Details?StateId=${id}`, accessToken);
    },
    stateEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/State/Update`, accessToken, formData);
    },
}
const districtConfiguration = {
    getDistrictList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filter) => {
        page = parseInt(page, 10);
        const { districtname, statename, districtstatus } = filter || {};
        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/DistrictList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=District asc`;
        }
        if (districtname || statename || districtstatus) {
            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];
            if (districtname) {
                if (districtname.toLowerCase() === nullFilter) {
                    filterArray.push('District eq null');
                } else {
                    filterArray.push(`contains(tolower(District),tolower('${districtname}'))`);
                }
            }
            // if (statename) {
            //     if (statename.toLowerCase() === nullFilter) {
            //         filterArray.push('StateName eq null');
            //     } else {
            //         filterArray.push(`contains(tolower(StateName),tolower('${statename}'))`);
            //     }
            // }
            if (statename) {
                if (statename?.toLowerCase() === nullFilter) {
                    filterArray.push('StateName eq null');
                } else {
                    if (statename.includes("%2C") || statename.includes(",")) {
                        const splitState = statename.split(`${statename.includes("%2C") ? "%2C" : ","}`);
                        const multiSelectState = splitState?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`(StateName in (${multiSelectState}))`);
                    }
                    else {
                        filterArray.push(`tolower(StateName) eq tolower('${statename}')`);
                    }
                }
            }
            if (districtstatus) {
                if (districtstatus.toLowerCase() === 'active') {
                    filterArray.push('IsActive eq true');
                } else {
                    filterArray.push(`IsActive eq false`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    districtCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/District/Update`, accessToken, formData);
    },
    districtEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/District/Update`, accessToken, formData);
    },
}

const anticoccidalConfiguration = {
    getAnticoccidalList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filter) => {
        page = parseInt(page, 10);
        const { anticoccidial, anticoccidialstatus } = filter || {};
        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/GetAnticoccidialList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=Anticoccidial asc`;
        }
        if (anticoccidial || anticoccidialstatus) {
            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];
            if (anticoccidial) {
                if (anticoccidial.toLowerCase() === nullFilter) {
                    filterArray.push('Anticoccidial eq null');
                } else {
                    filterArray.push(`contains(tolower(Anticoccidial),tolower('${anticoccidial}'))`);
                }
            }
            if (anticoccidialstatus) {
                if (anticoccidialstatus.toLowerCase() === 'active') {
                    filterArray.push('IsActive eq true');
                } else {
                    filterArray.push(`IsActive eq false`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
    anticoccidalCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/Anticoccidial/Update`, accessToken, formData);
    },
    anticoccidalEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/Setting/Anticoccidial/Update`, accessToken, formData);
    },
}

const customers = {
    getCustomerList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {

        const { customername, emailaddress, mobilenumber, address, customerstatus } = filters || {};
        page = parseInt(page, 10);

        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/CustomerMasterList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=CustomerName asc`
        }
        if (customername || emailaddress || mobilenumber || address || customerstatus) {

            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];

            if (customername) {
                if (customername.toLowerCase() === nullFilter) {
                    filterArray.push('CustomerName eq null');
                } else {
                    filterArray.push(`contains(tolower(CustomerName),tolower('${customername}'))`);
                }
            }
            if (emailaddress) {
                if (emailaddress.toLowerCase() === nullFilter) {
                    filterArray.push('email eq null');
                } else {
                    filterArray.push(`contains(tolower(email),tolower('${emailaddress}'))`);
                }
            }
            if (mobilenumber) {
                if (mobilenumber.toLowerCase() === nullFilter) {
                    filterArray.push('mobileNumber eq null');
                } else {
                    filterArray.push(`contains(tolower(mobileNumber),tolower('${mobilenumber}'))`);
                }
            }
            if (address) {
                if (address.toLowerCase() === nullFilter) {
                    filterArray.push('Address eq null');
                } else {
                    filterArray.push(`contains(tolower(Address),tolower('${address}'))`);
                }
            }
            if (customerstatus) {
                if (customerstatus.toLowerCase() === 'active') {
                    filterArray.push('IsActive eq true');
                } else {
                    filterArray.push(`IsActive eq false`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken)
    },
    getCustomerDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/CustomerMaster/Details?CustomerId=${id}`, accessToken);
    },
    customerCreate: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/CustomerMaster/Create`, accessToken, formData);
    },
    customerEdit: (accessToken, formData) => {
        return requests.postWithToken(`${apiUrl}/api/CustomerMaster/Update`, accessToken, formData);
    },
    getUsersOption: (accessToken, search, page, pageSize) => {
        let url = `${apiUrl}/odata/UserList?count=true`;
        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}&filter=(UserRoleName in ('User')) and IsActive eq true and IsEnabled eq true`;
        }
        else {
            url += `&filter=(UserRoleName in ('User')) and IsActive eq true and IsEnabled eq true`;
        }
        if (search) {
            url += ` and (contains(tolower(DisplayName),tolower('${encodeURIComponent(search)}')) or contains(tolower(Email),tolower('${encodeURIComponent(search)}')))`;
        }
        return requests.getWithToken(url, accessToken);
    },
}

const formulae = {
    getFormulaList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {

        const { reportname, datatype, metrics, isusedinformfield, createdby, createdon } = filters || {};
        page = parseInt(page, 10);

        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/CustomReportList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=CreatedTimeStamp desc`
        }
        if (reportname || datatype || metrics || isusedinformfield || createdby || createdon) {

            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];

            if (reportname) {
                if (reportname.toLowerCase() === nullFilter) {
                    filterArray.push('ReportName eq null');
                }
                else {
                    filterArray.push(`contains(tolower(ReportName),tolower('${reportname}'))`);
                }
            }
            if (datatype) {
                if (datatype.toLowerCase() === nullFilter) {
                    filterArray.push('DataType eq null');
                }
                else if (datatype.toLowerCase() === "number") {
                    filterArray.push(`contains(tolower(DataType),tolower('int'))`);
                }
                else {
                    filterArray.push(`contains(tolower(DataType),tolower('${datatype}'))`);
                }
            }
            if (metrics) {
                if (metrics.toLowerCase() === nullFilter) {
                    filterArray.push('Metrics eq null');
                } else {
                    filterArray.push(`contains(tolower(Metrics),tolower('${metrics}'))`);
                }
            }
            if (isusedinformfield) {
                if (isusedinformfield.toLowerCase() === 'yes') {
                    filterArray.push('IsFormFieldFormula eq true');
                } else {
                    filterArray.push(`IsFormFieldFormula eq false`);
                }
            }
            if (createdby) {
                if (createdby.toLowerCase() === nullFilter) {
                    filterArray.push('CreatedBy eq null');
                } else {
                    filterArray.push(`contains(tolower(CreatedBy),tolower('${createdby}'))`);
                }
            }
            if (createdon) {
                if (createdon?.toLowerCase() === nullFilter) {
                    filterArray.push('inspectiondate eq null');
                } else {
                    filterArray.push(`CreatedTimeStamp eq ${moment(createdon, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken)
    },
    getformulaExport: (accessToken, sortOrder, sortDirection, filters) => {

        const { reportname, datatype, metrics, createdby, createdon } = filters || {};

        let url = `${apiUrl}/CustomReportList/Export?$count=true`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=CreatedTimeStamp desc`
        }
        if (reportname || datatype || metrics || createdby || createdon) {

            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];

            if (reportname) {
                if (reportname.toLowerCase() === nullFilter) {
                    filterArray.push('ReportName eq null');
                }
                else {
                    filterArray.push(`contains(tolower(ReportName),tolower('${reportname}'))`);
                }
            }
            if (datatype) {
                if (datatype.toLowerCase() === nullFilter) {
                    filterArray.push('DataType eq null');
                }
                else if (datatype.toLowerCase() === "number") {
                    filterArray.push(`contains(tolower(DataType),tolower('int'))`);
                }
                else {
                    filterArray.push(`contains(tolower(DataType),tolower('${datatype}'))`);
                }
            }
            if (metrics) {
                if (metrics.toLowerCase() === nullFilter) {
                    filterArray.push('Metrics eq null');
                } else {
                    filterArray.push(`contains(tolower(Metrics),tolower('${metrics}'))`);
                }
            }
            if (createdby) {
                if (createdby.toLowerCase() === nullFilter) {
                    filterArray.push('CreatedBy eq null');
                } else {
                    filterArray.push(`contains(tolower(CreatedBy),tolower('${createdby}'))`);
                }
            }
            if (createdon) {
                if (createdon?.toLowerCase() === nullFilter) {
                    filterArray.push('inspectiondate eq null');
                } else {
                    filterArray.push(`CreatedTimeStamp eq ${moment(createdon, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken)
    },
    getFormfields: (accessToken, type) => {
        const filters = type ? `IsActive eq true and DataType eq '${type}'` : `IsActive eq true`;
        const sort = `OrderIdx asc`;
        const select = `FieldName,Id,DataType`;
        return requests.getWithToken(`${apiUrl}/odata/FormFieldList?$count=true&$filter=${encodeURIComponent(filters)}&$orderby=${sort}&$select=${select}`, accessToken);
    },
    formulaCreate: (accessToken, dataToSend) => {
        return requests.postWithToken(`${apiUrl}/api/CustomReport/Create`, accessToken, dataToSend);
    },
    getFormulaDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/CustomReport/Details?CustomReportId=${id}`, accessToken);
    },
    formulaEdit: (accessToken, dataToSend) => {
        return requests.postWithToken(`${apiUrl}/api/CustomReport/Update`, accessToken, dataToSend);
    },
    deleteFormula: (accessToken, Id) => {
        return requests.deleteWithToken(`${apiUrl}/api/CustomReport/Delete?ReportId=${Id}`, accessToken);
    },
    getFormulaeName: (accessToken, filter, page, pageSize) => {
        let url = `${apiUrl}/odata/CustomReportList?$select=Id,ReportName,CustomFormula,Fields,Metrics&$orderby=CreatedTimeStamp desc`;
        if (pageSize) {
            const pageNo = page || 0;
            url += `&$top=${pageSize}&$skip=${pageNo}`;
        }
        if (filter) {
            url += `&$filter=contains(tolower(ReportName),tolower('${encodeURIComponent(filter)}'))`
        }
        return requests.getWithToken(url, accessToken);
    },
    getReportGenerationList: (accessToken, page, pageSize, sortOrder, sortDirection, reportData, filters) => {

        const { reportname, fromdate, todate } = reportData || {};
        const { formrecordno, farmname, inspectiondate, location, region, state, district, examinedbirdscount, totalnoofbirdsplaced } = filters || {};
        const { value } = reportname || {};

        let url = `${apiUrl}/odata/ReportList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;
        if (value) {
            url += `&ReportId=${value}`;
        }
        if (fromdate) {
            url += `&FromDate=${fromdate}`;
        }
        if (todate) {
            url += `&ToDate=${todate}`;
        }
        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=InspectionDate desc`
        }
        if (formrecordno || farmname || inspectiondate || location || region || state || district || examinedbirdscount || totalnoofbirdsplaced) {

            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];

            if (formrecordno) {
                if (formrecordno?.toLowerCase() === nullFilter) {
                    filterArray.push('RecordsIndex eq null');
                } else {
                    filterArray.push(`RecordsIndex eq ${formrecordno}`);
                }
            }
            if (farmname) {
                if (farmname?.toLowerCase() === nullFilter) {
                    filterArray.push('farmname eq null');
                } else {
                    filterArray.push(`contains(tolower(farmname),tolower('${farmname}'))`);
                }
            }
            if (inspectiondate) {
                if (inspectiondate?.toLowerCase() === nullFilter) {
                    filterArray.push('inspectiondate eq null');
                } else {
                    filterArray.push(`inspectiondate eq ${moment(inspectiondate, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
                }
            }
            if (location) {
                if (location?.toLowerCase() === nullFilter) {
                    filterArray.push('location eq null');
                } else {
                    if (location.includes("%2C") || location.includes(",")) {
                        const splitLocation = location.split(`${location.includes("%2C") ? "%2C" : ","}`);
                        const multiSelectLocation = splitLocation?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`(Location in (${multiSelectLocation}))`);
                    }
                    else {
                        filterArray.push(`tolower(Location) eq tolower('${location}')`);
                    }
                }
            }
            if (region) {
                if (region?.toLowerCase() === nullFilter) {
                    filterArray.push('RegionName eq null');
                } else {
                    if (region.includes("%2C") || region.includes(",")) {
                        const splitRegion = region.split(`${region.includes("%2C") ? "%2C" : ","}`);
                        const multiSelectRegion = splitRegion?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`(RegionName in (${multiSelectRegion}))`);
                    }
                    else {
                        filterArray.push(`tolower(RegionName) eq tolower('${region}')`);
                    }
                }
            }
            if (state) {
                if (state?.toLowerCase() === nullFilter) {
                    filterArray.push('State eq null');
                } else {
                    if (state.includes("%2C") || state.includes(",")) {
                        const splitState = state.split(`${state.includes("%2C") ? "%2C" : ","}`);
                        const multiSelectState = splitState?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`(State in (${multiSelectState}))`);
                    }
                    else {
                        filterArray.push(`tolower(State) eq tolower('${state}')`);
                    }
                }
            }
            if (district) {
                if (district?.toLowerCase() === nullFilter) {
                    filterArray.push('District eq null');
                } else {
                    if (district.includes("%2C") || district.includes(",")) {
                        const splitDistrict = district.split(`${district.includes("%2C") ? "%2C" : ","}`);
                        const multiSelectDistrict = splitDistrict?.map((item) => `'${item}'`).join(', ');
                        filterArray.push(`(District in (${multiSelectDistrict}))`);
                    }
                    else {
                        filterArray.push(`tolower(District) eq tolower('${district}')`);
                    }
                }
            }
            if (examinedbirdscount) {
                if (examinedbirdscount?.toLowerCase() === nullFilter) {
                    filterArray.push('ExaminedBirdsCount eq null');
                } else {
                    filterArray.push(`ExaminedBirdsCount eq ${examinedbirdscount}`);
                }
            }
            if (totalnoofbirdsplaced) {
                if (totalnoofbirdsplaced?.toLowerCase() === nullFilter) {
                    filterArray.push('TotalNoOfBirdsPlaced eq null');
                } else {
                    filterArray.push(`TotalNoOfBirdsPlaced eq ${totalnoofbirdsplaced}`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken);
    },
}

const appVersion = {
    getAppVersionList: (accessToken, page, pageSize = 10, sortOrder, sortDirection, filters) => {
        const { versionno, releaseddate, notes, appname, createdby, createdon, updatedby, updatedon } = filters || {};

        page = parseInt(page, 10);

        if (Number.isNaN(page) || page < 1) {
            page = 1;
        }

        let url = `${apiUrl}/odata/AppVersionList?$count=true&$skip=${(page - 1) * pageSize}&$top=${pageSize}`;

        if (sortOrder && sortDirection) {
            url += `&$orderby=${sortOrder} ${sortDirection}`
        }
        else {
            url += `&$orderby=ReleasedDate desc`
        }
        if (versionno || releaseddate || notes || appname || createdby || createdon || updatedby || updatedon) {

            url += `&$filter=`;
            const nullFilter = encodeURIComponent('n/a')?.toLowerCase();
            const filterArray = [];

            if (versionno) {
                if (versionno?.toLowerCase() === nullFilter) {
                    filterArray.push('VersionNo eq null');
                } else {
                    filterArray.push(`contains(tolower(VersionNo),tolower('${versionno}'))`);
                }
            }
            if (notes) {
                if (notes?.toLowerCase() === nullFilter) {
                    filterArray.push('Notes eq null');
                } else {
                    filterArray.push(`contains(tolower(Notes),tolower('${notes}'))`);
                }
            }
            if (releaseddate) {
                if (releaseddate?.toLowerCase() === nullFilter) {
                    filterArray.push('ReleasedDate eq null');
                } else {
                    filterArray.push(`ReleasedDate eq ${moment(releaseddate, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
                }
            }
            if (appname) {
                if (appname?.toLowerCase() === nullFilter) {
                    filterArray.push('AppName eq null');
                } else {
                    filterArray.push(`contains(tolower(AppName),tolower('${appname}'))`);
                }
            }
            if (createdby) {
                if (createdby?.toLowerCase() === nullFilter) {
                    filterArray.push('CreatedBy eq null');
                } else {
                    filterArray.push(`contains(tolower(CreatedBy),tolower('${createdby}'))`);
                }
            }
            if (createdon) {
                if (createdon?.toLowerCase() === nullFilter) {
                    filterArray.push('CreatedTimeStamp eq null');
                } else {
                    filterArray.push(`CreatedTimeStamp eq ${moment(createdon, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
                }
            }
            if (updatedby) {
                if (updatedby?.toLowerCase() === nullFilter) {
                    filterArray.push('UpdatedBy eq null');
                } else {
                    filterArray.push(`contains(tolower(UpdatedBy),tolower('${updatedby}'))`);
                }
            }
            if (updatedon) {
                if (updatedon?.toLowerCase() === nullFilter) {
                    filterArray.push('UpdatedTimeStamp eq null');
                } else {
                    filterArray.push(`UpdatedTimeStamp eq ${moment(updatedon, "DD-MM-YYYY").format("YYYY-MM-DD")}`);
                }
            }

            let searchTerm = "";
            if (filterArray.length > 0) {
                searchTerm = filterArray.join(' and ');
            }
            if (searchTerm.length > 0) {
                url += `${searchTerm}`;
            }
        }
        return requests.getWithToken(url, accessToken)
    },
    getAppVersionDetails: (accessToken, id) => {
        return requests.getWithToken(`${apiUrl}/api/AppVersion/Details?Id=${id}`, accessToken);
    },
    appVersionCreate: (accessToken, formData) => {
        const currentTime = moment().format('HH:mm:ss');
        const postData = new FormData();
        postData.append('VersionNo', formData.VersionNo || "");
        postData.append('ReleasedDate', moment(`${formData.ReleasedDate} ${currentTime}`, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"));
        postData.append('Notes', formData.Notes || "");
        postData.append('AppAPK', formData.AppAPK?.length > 0 ? formData.AppAPK[0] : "");
        return requests.postMultiPartWithToken(`${apiUrl}/api/AppVersion/Create`, accessToken, postData);
    },
    appVersionEdit: (accessToken, formData) => {
        const currentTime = moment().format('HH:mm:ss');
        const postData = new FormData();
        postData.append('Id', formData.id);
        postData.append('VersionNo', formData.versionNo || "");
        postData.append('ReleasedDate', moment(`${formData.releasedDate} ${currentTime}`, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"));
        postData.append('Notes', formData.notes || "");
        postData.append('AppAPK', formData.appAPK?.length > 0 ? formData.appAPK[0] : "");
        return requests.postMultiPartWithToken(`${apiUrl}/api/AppVersion/Update`, accessToken, postData);
    }
}

const downloadAPK = {
    getDownloadAPK: () => {
        return requests.getWithoutToken(`${apiUrl}/api/AppVersion/GetAPK`);
    }
}

export default {
    authentication, dashboards, users, formConfiguration, regionConfiguration, stateConfiguration, districtConfiguration,
    anticoccidalConfiguration, farmRecords, customers, formulae, labRecords, appVersion, downloadAPK
}